// Globals
import React, { useMemo } from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';

// UI
import { Menu } from 'antd';

// Locals
import {
  setAccountPage,
  setPaddleAccountDetails,
  setPaddleTransactions,
} from '../../actions';

// Types
import { IState } from '../../graphql/types';

const AccountMenuLeft: React.FC = () => {
  const dispatch = useDispatch();

  const accountPage = useSelector<IState, string | undefined>(
    state => state.accountPage
  );

  const pagesList = useMemo(() => ['Profile', 'Password', 'Subscription'], []);

  const menuItems = useMemo(() => {
    return pagesList.map(item => {
      const handleClick = () => {
        batch(() => {
          dispatch(setPaddleAccountDetails(undefined));
          dispatch(setPaddleTransactions(undefined));
          dispatch(setAccountPage(item));
        });
      };

      return {
        key: item,
        label: (
          <div key={item} onClick={handleClick}>
            {item}
          </div>
        ),
      };
    });
  }, [dispatch, pagesList]);

  return (
    <Menu
      theme={'light'}
      defaultSelectedKeys={['profile']}
      style={{ borderRight: 'none' }}
      selectedKeys={accountPage ? [accountPage] : undefined}
      items={menuItems}
    />
  );
};

export default AccountMenuLeft;
